import * as Yup from "yup";
import _ from "lodash";
import { getRecordsToOverride, SelectedPrimaryRecords } from "./Utils";

const ValidationSchema = (attributeValues, props) => {
  return Yup.object()
    .shape({
      override_action: Yup.string().required("Required"),
      override_attribute: Yup.string().required("Required"),
      override_system: Yup.string().when("override_attribute", {
        is: (attribute) => ["identifier"].includes(attribute),
        then: Yup.string().required("Required"),
        otherwise: (schema) => schema.notRequired(),
      }),
      override_attrCode: Yup.string().when("override_attribute", {
        is: (attribute) =>
          ["phone", "email", "address", "name"].includes(attribute),
        then: (schema) => Yup.string().required("Required"),
        otherwise: (schema) => schema.notRequired(),
      }),
      override_code: Yup.string().when("override_system", {
        is: (system) => system === "[No System]",
        then: Yup.string().required("Required"),
        otherwise: (schema) => schema.notRequired(),
      }),
      override_correct_value: Yup.string().when("override_action", {
        is: (action) => action === "replace",
        then: (schema) =>
          schema
            .required("Required")
            .test(
              "notSameAsIncorrectValue",
              "Cannot be the same as Incorrect Value",
              function (value) {
                const { override_incorrect_value } = this.parent;
                if (value && override_incorrect_value) {
                  return value !== override_incorrect_value;
                }
                return true;
              },
            ),
        otherwise: (schema) => schema.notRequired(),
      }),
      override_incorrect_value: Yup.string().when("override_action", {
        is: (action) => action === "replace",
        then: (schema) =>
          schema
            .required("Required")
            .test(
              "notSameAsCorrectValue",
              "Cannot be the same as Correct Value",
              function (value) {
                const { override_correct_value } = this.parent;
                if (value && override_correct_value) {
                  return value !== override_correct_value;
                }
                return true;
              },
            ),
        otherwise: (schema) => schema.notRequired(),
      }),
    })
    .test({
      name: "minimumOneValueOverridden",
      message: "There must be at least one value overridden",
      test: (values) => {
        if (
          values.override_attribute &&
          values.override_action &&
          values.override_incorrect_value
        ) {
          const records = getRecordsToOverride(
            attributeValues,
            values.override_attribute,
            values.override_system,
            values.override_attrCode,
            values.override_action,
            values.override_incorrect_value,
            values.override_code,
          );
          return typeof records !== "undefined" && !_.isEmpty(records);
        }
      },
    });
};

export default ValidationSchema;
